import { render, staticRenderFns } from "./EbirdHeaderFooter.vue?vue&type=template&id=9a0497de&"
import script from "./EbirdHeaderFooter.vue?vue&type=script&lang=js&"
export * from "./EbirdHeaderFooter.vue?vue&type=script&lang=js&"
import style0 from "./EbirdHeaderFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports